export default {
  ticketCollection: [], // 可取门票列表
  touristInfo: [] // 取票需要登记的信息
};
